// src/components/PeoplePlan/EmployeeManagement/Dialogs/NotificationBanner.js
import React from "react";
import styles from "./Dialogs.module.css";

const NotificationBanner = ({ notification }) => {
  if (!notification.show) return null;

  return (
    <div className={`${styles.notification} ${styles[notification.type]}`}>
      {notification.message}
    </div>
  );
};

export default NotificationBanner                   ;